<!-- 予約確認ページのコンテナ -->
<template lang="html">
  <div id="reservationListPage">
    <h2>予約リスト</h2>
    <div class="cp_iptxt">
    	<input class="ef" type="text" v-model="Keyword">
    	<label>お名前</label>
    	<span class="focus_line"></span>
    </div>
    <div class="date">
      <input type="month" v-model="date">
    </div>
    <table id="reservationList" border="1">
      <thead class="bluedBackground">
        <th class="colID">予約番号</th>
        <th class="colDate">日付</th>
        <th class="colStartTime">開始時刻</th>
        <th class="colEndTime">終了時刻</th>
        <th class="colStudent">生徒名</th>
        <th class="colTeacher">教師名</th>
        <th class="colClassroom">教室名</th>
        <th class="colRecurrence">繰り返し予約</th>
        <th class="colOnline">授業形態</th>
      </thead>
      <tbody>
        <tr v-for="(reservation, index) in SortedList" :key="reservation.id"
        :class="{ evenRow: index % 2 === 0 }">
          <td class="colID">{{reservation.id}}</td>
          <td class="colDate">{{reservation.date}}</td>
          <td class="colStartTime">{{reservation.start_time.slice(0, 5)}}</td>
          <td class="colEndTime">{{reservation.end_time.slice(0, 5)}}</td>
          <td class="colStudent">{{reservation.student.fullname}}</td>
          <td class="colTeacher">{{reservation.teacher.fullname}}</td>
          <td class="colClassroom">{{reservation.classroom}}</td>
          <td class="colRecurrence">{{ getWhetherRecurrent(reservation.recurrence_id) }}</td>
          <td class="colOnline">{{ Number(reservation.online)===1 ? "オンライン" : "対面"}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import reservationsApi from '@/api/reservations'
import router from '@/router/index'
import {mapGetters} from 'vuex'
// import T from '@/modules/time'
export default {
  data () {
    return {
      reservations: [{
        id: 0,
        student: { fullname: '' },
        teacher: { fullname: '' },
        classroom: '',
        date: '1990-01-01',
        start_time: '10:00',
        end_time: '10:00',
        recurrence_id: 0
      }],
      sort: {
        isDecending: false,
        column: 'date'
      },
      Keyword: null,
      date: null
    }
  },
  methods: {
    getWhetherRecurrent (rid) {
      if (rid === 0 || rid === undefined || rid === null) {
        return 'NO'
      } else {
        return 'YES (id:' + rid + ')'
      }
    },
    columnClickHandler (column) {
      this.sort.column = column
      this.sort.isDecending = !this.sort.isDecending
    },
    getAssendingArrow (column) {
      if (this.sort.column === column) {
        return this.sort.isDecending ? '↑' : ' ↓'
      }
      return ''
    },
    kanaToHira (str) {
      return str.replace(/[\u3041-\u3096]/g, function (match) {
        var chr = match.charCodeAt(0) + 0x60
        return String.fromCharCode(chr)
      })
    },
    getReservations () {
      const updateList = () => {
        // stateを使わないので直にAPI呼び出し
        if (this.$store.state.userInfo.user_type === 'admin') {
          reservationsApi.get(this.$store.state.userInfo.school_id).then((res) => {
            this.reservations = res.data.reservations
          }).catch((err) => {
            if (err.response) {
              let status = err.response.status
              let message = err.response.data.message
              if (status === 401) {
                alert('セッションがタイムアウトしました　再度ログインして下さい')
                router.push('/login')
              } else {
                console.log(message)
                alert('予約情報取得に失敗しました：' + message)
              }
            } else {
              alert('Error:' + err.message)
            }
          })
        } else {
          reservationsApi.getByUserId(this.$store.state.userInfo.user_id)
          .then((res) => {
            this.reservations = res.data.reservations
          }).catch((err) => {
            if (err.response) {
              let status = err.response.status
              let message = err.response.data.message
              if (status === 401) {
                alert('セッションがタイムアウトしました　再度ログインして下さい')
                router.push('/login')
              } else {
                console.log(message)
                alert('予約情報取得に失敗しました：' + message)
              }
            } else {
              alert('Error:' + err.message)
            }
          })
        }
      }
      if (!this.$store.state.userInfo['user_type']) {
        this.$store.dispatch('getUserInfo').then(updateList)
      } else {
        updateList()
      }
    }
  },
  mounted () {
    this.getReservations()
  },
  computed: {
    ...mapGetters([
      'school_id'
    ]),
    SortedList () {
      if (this.date && this.Keyword) {
        return this.reservations.filter((data, index, array) => {
          return data.date.match(this.date) && (data.student.fullname.match(this.Keyword) || data.student.kana.match(this.Keyword) || data.student.kana.match(this.kanaToHira(this.Keyword)) || data.teacher.fullname.match(this.Keyword) || data.teacher.kana.match(this.Keyword) || data.teacher.kana.match(this.kanaToHira(this.Keyword)))
        })
      }
      if (this.date && !this.Keyword) {
        return this.reservations.filter((data, index, array) => {
          return data.date.match(this.date)
        })
      }
      if (!this.date && this.Keyword) {
        return this.reservations.filter((data, index, array) => {
          return data.student.fullname.match(this.Keyword) || data.student.kana.match(this.Keyword) || data.student.kana.match(this.kanaToHira(this.Keyword)) || data.teacher.fullname.match(this.Keyword) || data.teacher.kana.match(this.Keyword) || data.teacher.kana.match(this.kanaToHira(this.Keyword))
        })
      }
      return this.reservations
    }
  },
  watch: {
    school_id () {
      this.getReservations()
    }
  }
}
</script>

<style lang="css" scoped>
#reservationList {
  width: 90%;
  margin: auto;
}
th {
  text-align: center;
  color: white;
  font-style: bold;
}
.evenRow {
  background-color: #ffffcc
}
tbody>tr:hover {
  background-color: #ffcccc
}
.cp_iptxt {
	position: relative;
	width: 20%;
	margin: 40px 3%;
  text-align: left;
}
.cp_iptxt input[type='text'] {
	font: 15px/24px sans-serif;
	box-sizing: border-box;
	width: 100%;
	letter-spacing: 1px;
	padding-left: 4em;
}
.cp_iptxt input[type='text']:focus {
	outline: none;
}
.ef {
	padding: 4px 0;
	border: 0;
	border-bottom: 1px solid #1b2538;
	background-color: transparent;
}
.ef ~ .focus_line {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 0;
	height: 2px;
	transition: 0.4s;
	background-color: #da3c41;
}
.ef:focus ~ .focus_line,
.cp_iptxt.ef ~ .focus_line {
	width: 100%;
	transition: 0.4s;
}
.ef ~ label {
	position: absolute;
	z-index: -1;
	top: 4px;
	left: 0;
	width: 100%;
	transition: 0.3s;
	letter-spacing: 0.5px;
	color: #aaaaaa;
}
.ef:focus ~ label, .cp_iptxt.ef ~ label {
	font-size: 12px;
	top: -16px;
	transition: 0.3s;
	color: #da3c41;
}
.datepicker{
  display: inline-block;
}
.date{
  float: left;
  margin: 10px 50px;
}
</style>



// WEBPACK FOOTER //
// ReservationListPage.vue?1b341afe